export default __webpack_public_path__ + "static/media/resumeexample.9079127d.png";